
const isProd = process.env.REACT_APP_SERVER === 'Prod'

let _LR = null

// Function to identify user in LogRocket
export function identifyUser() {
  if (!_LR) return null
  
  try {
    const userData = JSON.parse(localStorage.getItem('userData'))
    if (userData) {
      _LR.identify(userData.id, {
        name: userData.fullName || userData.username,
        email: userData.email,
        role: userData.role,
        companyCode: userData.companyCode,
        department: userData.department,
        jobTitle: userData.jobTitle,
        lastIdentified: new Date().toISOString()
      })
      return true
    }
  } catch (err) {
    console.error('LogRocket user identification failed', err)
  }
  return false
}

export async function init() {
  if (!isProd) return
  try {
    const LogRocket = (await import('logrocket')).default
    const setupLogRocketReact = (await import('logrocket-react')).default
    const id = process.env.REACT_APP_LOGROCKET_ID || 'dbeihy/shipsmpl20'
    LogRocket.init(id)
    
    // Get user data from localStorage
    const userData = JSON.parse(localStorage.getItem('userData'))
    if (userData) {
      LogRocket.identify(userData.id, {
        name: userData.fullName || userData.username,
        email: userData.email,
        role: userData.role,
        companyCode: userData.companyCode,
        department: userData.department,
        jobTitle: userData.jobTitle
      })
    }
    
    setupLogRocketReact(LogRocket)
    _LR = LogRocket
    // expose for any legacy code that expects a global
    try {
      window.LogRocket = LogRocket
      // Expose the identify function globally
      window.LogRocket.identifyUser = identifyUser

    } catch (e) {
      // ignore if window isn't available
    }
  } catch (err) {
    // Don't crash the app if LogRocket fails to load
    // eslint-disable-next-line no-console
    console.error('LogRocket initialization failed', err)
  }
}

export function track(...args) {
  if (_LR && typeof _LR.track === 'function') return _LR.track(...args)
  return null
}

export function log(...args) {
  if (_LR && typeof _LR.log === 'function') return _LR.log(...args)
  return null
}

export function isEnabled() {
  return !!_LR
}
